import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CartItem } from '../types/Cart';

interface CartState {
  items: CartItem[];
}

// Load cart from localStorage
const loadCartFromLocalStorage = (): CartItem[] => {
  try {
    const serializedCart = localStorage.getItem('cart');
    return serializedCart ? JSON.parse(serializedCart) : [];
  } catch (e) {
    console.error('Could not load cart from localStorage', e);
    return [];
  }
};

// Initial state
const initialState: CartState = {
  items: loadCartFromLocalStorage(),
};

// Save cart to localStorage whenever it changes
const saveCartToLocalStorage = (cart: CartItem[]) => {
  try {
    const serializedCart = JSON.stringify(cart);
    localStorage.setItem('cart', serializedCart);
  } catch (e) {
    console.error('Could not save cart to localStorage', e);
  }
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<CartItem>) => {
      debugger;
      const existingItem = state.items.find(
        (item) =>
          item.id === action.payload.id && item.size === action.payload.size
      );

      if (existingItem) {
        existingItem.quantity += action.payload.quantity;
      } else {
        state.items.push(action.payload);
      }
      saveCartToLocalStorage(state.items);
    },
    removeFromCart: (
      state,
      action: PayloadAction<{ id: string; size: string | undefined }>
    ) => {
      state.items = state.items.filter(
        (item) =>
          !(item.id === action.payload.id && item.size === action.payload.size)
      );
      saveCartToLocalStorage(state.items);
    },
    updateQuantity: (
      state,
      action: PayloadAction<{ id: string; size: string | undefined; quantity: number }>
    ) => {
      const itemToUpdate = state.items.find(
        (item) =>
          item.id === action.payload.id && item.size === action.payload.size
      );

      if (itemToUpdate) {
        itemToUpdate.quantity = action.payload.quantity;
        // Optionally remove items with 0 quantity
        if (itemToUpdate.quantity <= 0) {
          state.items = state.items.filter(
            (item) =>
              !(item.id === action.payload.id && item.size === action.payload.size)
          );
        }
      }
      saveCartToLocalStorage(state.items);
    },
  },
});

export const { addToCart, removeFromCart, updateQuantity } = cartSlice.actions;

export default cartSlice.reducer;
